/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC } from 'react'
import { PaymentOption } from '../../../core/_models'
import { formatDateTime } from '../../../../../utils/dayJs/format'

type Props = {

    paymentOption: PaymentOption
}

const CreatedInCell: FC<Props> = ({ paymentOption }) => (

    <div className='d-flex flex-column'>
        <a href='#' className='text-gray-800 text-hover-danger mb-1'>
            {paymentOption.createdAt ? formatDateTime(paymentOption.createdAt.toString()) : 'N/A'}
        </a>
        {/* <span>{franchise.createdAt ? franchise.createdAt.toString() : 'N/A'}</span> */}
    </div>
)

export { CreatedInCell }
